export const profiles = [
  "Collégien",
  "Lycéen",
  "Etudiant",
  "Apprenti",
  "En recherche d'emploi",
  "En activité professionnelle",
  "Dirigeant d'entreprise",
];
